<template>
	<div
		v-if="selectedFilters"
		:class="[
			'dc-post-grid-selected-filters',
		]"
	>
		<button
			v-for="activeFilter in selectedFilters"
			:class="[
				'selected-filter',
				'dc-button',
				'dc-button--has-title',
				'dc-button--has-icon',
			]"
			@click.stop.prevent="removeFilter(activeFilter.filter, activeFilter.value)"
		>
			{{ activeFilter.label }}
		</button>
	</div>
</template>
<script>
export default {
	data() {
		return {
			selectedFilters: []
		}
	},
	props: {
		filters: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		}
	},
	methods: {
		removeFilter(filterName, valueToRemove) {
			let usesMultiselect = true;
			this.filters.forEach((filter) => {
				if (filter.name===filterName) {
					usesMultiselect = filter.multiselect || usesMultiselect;
					this.selectedFilters.forEach((activeFilter, index) => {
						if (activeFilter.filter===filterName && activeFilter.value===valueToRemove) {
							this.selectedFilters = this.selectedFilters.filter(item => item.value !== valueToRemove)
						}
					})
				}
			})	
			this.$emit('update-filter', filterName, valueToRemove, usesMultiselect);
		},
		updateSelectedFilters(model) {
			if (this.filters.length>0) {
				this.filters.forEach((filter) => {
					if (filter.type==='default') {
						const selectedFilterValues = (typeof model[filter.name] !== 'undefined') ? Object.values({ ...model[filter.name] }) : [];
						if (selectedFilterValues.length>0) {
							let filterOptions = [];
							if (typeof filter.options[0].parent_term !== 'undefined') {
								filter.options.forEach((filterGroup) => {
									filterGroup.options.forEach((value) => {
										filterOptions.push(value)
									})
								})
							} else {
								filterOptions = filter.options;
							}
							filterOptions.forEach((option) => {
								let tmpOption = option;
								tmpOption.filter = filter.name
								if (selectedFilterValues.includes(option.value)) {
									if (!this.selectedFilters.includes(tmpOption)) {
										this.selectedFilters.push(tmpOption)
									} 
								} else {
									if (this.selectedFilters.includes(tmpOption)) {
										const tmpOptionIndex = this.selectedFilters.indexOf(tmpOption);
										if (tmpOptionIndex > -1) {
											this.selectedFilters.splice(tmpOptionIndex, 1);
										}
									} 
								}
							})
						} else {
							this.selectedFilters.forEach((selectedFilter, selectedFilterIndex) => {
								const selectedFilterName = (typeof selectedFilter.name !== 'undefined') ? selectedFilter.name : selectedFilter.filter;
								if (selectedFilterName===filter.name) {
									this.selectedFilters.splice(selectedFilterIndex, 1);
								}
							})
						}
					}
				})
			}
		}
	},
	watch: {
		form: {
			handler(currentFilters) {
				this.updateSelectedFilters(currentFilters);
			}, 
			deep: true
		}
	}
};
</script>
